/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-header[_ngcontent-%COMP%]{display:block;background-color:#fff;z-index:9;width:100%}@media (min-width:992px){app-header[_ngcontent-%COMP%]{height:92px}}.content[_ngcontent-%COMP%]{background-color:#132350;max-width:1600px;margin:0 auto;overflow:hidden}nz-card[_ngcontent-%COMP%]{margin:32px}"];
export { styles as styles };
